"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralEasyFilterControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
var ControlsGeneralEasyFilterControl;
(function (ControlsGeneralEasyFilterControl) {
    class Config {
        static component = 'easyFilter';
        static itemClassName = "EasyFilterControl-content-item";
        static typeIdDataName = "type";
        static activeClassName = "active";
    }
    class Control {
        static initialize(props) {
            this.triggerActions(props);
        }
        static getEasyFilterType(easyFilterId) {
            const easyFilter = DOM_1.DOM.Parser.getHtmlElement(easyFilterId);
            const active = DOM_1.DOM.Parser.getHtmlElementByClass(Config.activeClassName, easyFilter);
            return parseInt(DOM_1.DOM.Parser.getDataByNameFromElement(Config.typeIdDataName, active));
        }
        static triggerActions(props) {
            const easyFilter = DOM_1.DOM.Parser.getHtmlElement(props.easyFilterId);
            const triggers = DOM_1.DOM.Parser.getHtmlElements(Config.itemClassName, easyFilter);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                const typeId = parseInt(DOM_1.DOM.Parser.getDataByNameFromElement(Config.typeIdDataName, trigger));
                trigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    props.callback(typeId, event);
                });
            }
        }
    }
    ControlsGeneralEasyFilterControl.Control = Control;
})(ControlsGeneralEasyFilterControl || (exports.ControlsGeneralEasyFilterControl = ControlsGeneralEasyFilterControl = {}));
